import { Component, inject, signal, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet, Router, NavigationEnd } from '@angular/router';
import { HeaderComponent } from '../../header/header';
import { SidebarComponent } from '../../sidebar/sidebar';
import { CommonService } from '../../../../core/services/common';

@Component({
  selector: 'app-main-layout',
  standalone: true,
  imports: [CommonModule, RouterOutlet, SidebarComponent],
  templateUrl: './main-layout.html',
  styleUrls: ['./main-layout.scss'],
})
export class MainLayoutComponent {
  // Sidebar states
  isSidebarOpen = signal(window.innerWidth >= 768);
  isMobile = signal(window.innerWidth < 768);
  windowWidth = signal(window.innerWidth);
  showSearchPopup = signal(false);
  activeChild: any;
  common = inject(CommonService);
  router = inject(Router);

  issidebarCollapsed: boolean = false;
  showChangePassword = signal(false);
  @ViewChild(SidebarComponent) sidebarComponent!: SidebarComponent;


  constructor() {
    window.addEventListener('resize', () => {
      const width = window.innerWidth;
      this.windowWidth.set(width);
      const mobile = width < 768;
      this.isMobile.set(mobile);
      if (mobile) this.isSidebarOpen.set(false);
    });

    // Listen to route changes to update heading
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const title = this.router.routerState.root.firstChild?.snapshot.data?.['title'];
        if (title) {
          this.common.setHeading(title);
        }
      }
    });
  }

  toggleSidebar() {
    this.isSidebarOpen.set(!this.isSidebarOpen());

    if (this.activeChild && 'onSidebarStateChange' in this.activeChild) {
      // notify child about sidebar state
      this.activeChild.onSidebarStateChange(!this.isSidebarOpen());
    }
  }

  closeSidebar() {
    this.isSidebarOpen.set(false);
  }
  heading(event: any) {
    console.log("Previous heading:", this.common.getHeading());
    console.log("New heading:", event);
    this.common.setHeading(event);
    console.log("Updated heading:", this.common.getHeading());
  }
  // Handle sidebar collapse/expand
  collapseSidebar() {
    this.issidebarCollapsed = !this.issidebarCollapsed;

    if (this.activeChild && 'onSidebarCollapseChange' in this.activeChild) {
      this.activeChild.onSidebarCollapseChange(this.issidebarCollapsed);
    }
  }


  onToggleSidebarFromChild() {
    this.collapseSidebar();
  }
  openSearchPopup() {
    this.showSearchPopup.set(true);
  }
  onChildActivated(childComponent: any) {
    this.activeChild = childComponent;

    // Send initial collapse state
    if ('onSidebarCollapseChange' in this.activeChild) {
      this.activeChild.onSidebarCollapseChange(this.issidebarCollapsed);
    }

    // Optionally: also handle open/close signals
    if (this.isSidebarOpen()) {
      if ('onSidebarOpened' in this.activeChild) {
        this.activeChild.onSidebarOpened();
      }
    } else {
      if ('onSidebarClosed' in this.activeChild) {
        this.activeChild.onSidebarClosed();
      }
    }
  }


  closeSearchPopup() {
    this.showSearchPopup.set(false);
  }

  openChangePasswordDialog() {
    this.showChangePassword.set(true);
  }

  closeChangePassword() {
    this.showChangePassword.set(false);
  }

  getWindowWidth(): number {
    return this.windowWidth();
  }

}